import React, { FC } from 'react'
import { StopClickEventPropagation, Box } from 'ui-components'

import TableRow from '../../table-row'

type OnClick =
  | ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void)
  | undefined

const hideStyle = { display: 'none' }
const ChildRow: FC<{
  colSpan: number
  highlight?: boolean
  dashboardHighlight?: boolean
  closeRowChild: () => void
  children?: React.ReactNode
}> = ({ colSpan, highlight, dashboardHighlight, closeRowChild, children }) => {
  if (!children) {
    return null
  }
  const closeChildClick: OnClick = () => {
    closeRowChild()
  }
  return (
    <>
      <tr style={hideStyle}>
        <td
          style={hideStyle}
          className="child-row-omni-cell"
          colSpan={colSpan}
        />
      </tr>
      <TableRow
        className="child-row"
        $highlight={highlight}
        $dashboardHighlight={dashboardHighlight}
      >
        <td className="child-row-omni-cell" colSpan={colSpan}>
          <StopClickEventPropagation>
            <Box onClick={closeChildClick} style={{ maxWidth: '1200px' }}>
              <StopClickEventPropagation>{children}</StopClickEventPropagation>
            </Box>
          </StopClickEventPropagation>
        </td>
      </TableRow>
    </>
  )
}

export default ChildRow
